import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		reportName: '보고서',
		reportMatchSeqNo: 0,
		reportPno: 0,
		programType: '',
		reportYm: '',
	},
	mutations: {
		setReportName(state, payload) {
			state.reportName = payload;
		},
		setReportNo(state, payload) {
			state.reportMatchSeqNo = payload.matchSeqNo;
			state.reportPno = payload.pNo;
		},
		setFinalReportNo(state, payload) {
			state.reportMatchSeqNo = payload.matchSeqNo;
			state.programType = payload.programType;
		},
		setMonthlyReportNo(state, payload) {
			state.reportMatchSeqNo = payload.matchSeqNo;
			state.reportYm = payload.reportYm;
		},
	},
});
